import CloseIcon from "static/svg/close.svg";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { componentStyles } from "./live-board-screen-component.scss";
import EmbeddedBoard from "segments/desktop/core-components/embedded-board/embedded-board";

const liveBoardScreenComponent = (props) => {
  const { translate, closeLiveBoard } = props;

  const onKeyDown = generateOnKeyDownHandler(closeLiveBoard);
  const renderCloseIcon = () => {
    return (
      <div
        className="live-board-close"
        onClick={closeLiveBoard}
        onKeyDown={onKeyDown}
        tabIndex={0}
        role="button"
        aria-label={translate("liveBoard.close")}
      >
        <CloseIcon className="close-icon" />
      </div>
    );
  };

  return (
    <div className="live-board-screen">
      {renderCloseIcon()}
      <div className="live-board-content-wrapper">
        <div className="live-board-content">
          <EmbeddedBoard />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default liveBoardScreenComponent;
